import React, { Component } from "react";

const DoneBackground = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M127.861 8.69269C107.083 2.72127 85.5482 -0.203122 63.9303 0.0109554C42.3124 -0.203122 20.7779 2.72127 0 8.69269L0 119.205C20.7779 125.176 42.3124 128.101 63.9303 127.887C85.5482 128.101 107.083 125.176 127.861 119.205V8.69269Z"
        fill={fill}
      />
    </svg>
  );
};

DoneBackground.defaultProps = {
  width: 128,
  height: 128,
  fill: "#E31C79",
};

export default DoneBackground;
